const { Form } = require('antd');
const { message } = require('antd');
const { useState, useEffect, useCallback } = require('react');
const { consultationService } = require('../../../services/medicalConsultation');

const useImportAnamnesisModal = ({
  t,
  admissionPatientId,
  serviceId,
  serviceType,
  servicesList,
  patientFullName,
  countryCode,
  healthForm,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [availableAnamneses, setAvailableAnamneses] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedAnamnesis, setSelectedAnamnesis] = useState(null);

  const fetchAvailableAnamneses = async () => {
    if ([serviceId, serviceType, admissionPatientId].some(value => !value)) {
      console.error('Missing required parameters for fetching anamneses');
      message.error({
        content: 'Error al obtener las anamnesis disponibles',
        style: { marginTop: '45vh' },
      });
      return;
    }
    try {
      setLoading(true);
      const response = await consultationService.getAvailableAnamneses({ 
        admission_patient_id: admissionPatientId,
        service_id: serviceId,
        service_type: serviceType,
      });
      
      const formattedAnamneses = response.map(item => ({
        id: item.id,
        service_id: item.consultation_id,
        name: servicesList.find(service => service.id === item.consultation_id)?.name || 'Servicio no encontrado',
        anamnesis: item.comment,
        created_at: item.created_at,
      }));
      
      setAvailableAnamneses(formattedAnamneses);
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Error al obtener las anamnesis disponibles',
        style: { marginTop: '45vh' },
      });
    } finally {
      setLoading(false);
    }
  };

  const showModal = async () => {
    setModalVisible({ state: true });
    await fetchAvailableAnamneses();
  };

  const closeModal = useCallback(() => {
    form.resetFields();
    setSelectedAnamnesis();
    setModalVisible({ state: false, type: null, from: null });
  }, [form]);

  const onCheck = (e) => {
    setSelectedAnamnesis(e.target.value);
  }

  const importAnamnesis = () => {
    if (!selectedAnamnesis) {
      message.error({ 
        content: 'Seleccione una anamnesis para importar', 
        style: { marginTop: '45vh' } 
      });
      return;
    }
  
    healthForm.setFieldsValue({
      comment: selectedAnamnesis.anamnesis
    });

    message.success({
      content: 'Anamnesis importada correctamente',
      style: {
        marginTop: '45vh',
      },
    })
  
    closeModal();
  };

  return {
    modalVisible,
    setModalVisible,
    closeModal,
    showModal,
    patientFullName,
    availableAnamneses,
    form,
    loading,
    onCheck,
    importAnamnesis,
    selectedAnamnesis,
  };
}

export default useImportAnamnesisModal;
